<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="openAddmision">
                            <div class="col-lg-12">
                                <div class="card custom-card">
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/images/receipt.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Admission Open College List
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            List Of Admission Open College List
                                                        </p>
                                                    </div>
                                                </div>
                                                <!-- <h3 class="main-content-label mb-1 ">
                                                    <b>List Of Admission Fee Templates</b>
                                                </h3> -->
                                            </div>
                                            <div class="col-md-3" >
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>District</mat-label>
                                                            <mat-select formControlName="StuDistrictAd"  placeholder="District"
                                                                class="colorblack" #select176>
                                                                <mat-select-filter *ngIf="select176.focused" [placeholder]="'Filter'"
                                                                    [displayMember]="'DsName'" [array]="districtList"
                                                                    (filteredReturn)="filteredListdistrictCode =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredListdistrictCode"
                                                                    [value]="item.DsCode" (click)="getCollegeData(item.DsCode)">
                                                                    {{item.DsName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3" >
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Study Center</mat-label>
                                                            <mat-select formControlName="StuStudyCenter"  placeholder="Study Center"
                                                                class="colorblack" #select177>
                                                                <mat-select-filter *ngIf="select177.focused" [placeholder]="'Filter'"
                                                                    [displayMember]="'CgName'" [array]="collegedataList"
                                                                    (filteredReturn)="filteredListCollege =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredListCollege"
                                                                    [value]="item.CgCode" (click)="fetchAllSessionCutoff3(item.CgCode)">
                                                                    {{item.CgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-2" [formGroup]="OpenAdmSearchForm">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Search
                                                    </mat-label> <input class="color" matInput placeholder="Search"
                                                        (keyup)="keypress()" formControlName="SearchString">
                                                    <mat-icon matSuffix>search</mat-icon>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <hr>
                                        <div class="row clearfix mt-2">
                                            <div class="table-responsive table-container tab mt-1">
                                                <table class="table table-bordered  text-left">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">
                                                                College Name
                                                            </th>
                                                            <th class="f600">
                                                                Course Name
                                                            </th>
                                                            <th class="f600">
                                                                Cut-Off From Date
                                                            </th>
                                                            <th class="f600">
                                                                Cut-Off To Date
                                                            </th>
                                                            <th class="f600">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let data of SessionCutOffList; let i = index"
                                                            class="text-left">

                                                            <td>
                                                                {{data.CgName}}
                                                            </td>
                                                            <td>
                                                                {{data.CoName}} </td>

                                                            <td>
                                                                {{data.FromDate | date: 'dd/MM/yyyy'}} </td>
                                                            <td>
                                                                {{data.ToDate | date: 'dd/MM/yyyy'}}
                                                                <!-- <h6 *ngIf="AdmClosed" class="mb-1 reddd"><b>
                                                                    For the selected college and course, admissions are not open</b></h6> -->
                                                            </td>
                                                            <td>
                                                                <button type="button" [disabled]="saveBtn"
                                                                    class="btn sz btn-primary btn-icon-text  mt-1 fr"
                                                                    (click)="openConformationModalBox(data)">
                                                                    <span
                                                                        style="display: contents; align-items: center;">
                                                                        <img width="20vh"
                                                                            src="../../assets/images/pay-per-click.gif"
                                                                            style="margin-right: 5px;">
                                                                        Apply
                                                                    </span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                            <mat-paginator [length]="totalItems" [pageSize]="pageSize"
                                        [pageSizeOptions]="pageSizeOptions"
                                        (page)="onPageChange($event)"></mat-paginator>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>